import { render, staticRenderFns } from "./NotificationChannelModal.vue?vue&type=template&id=2c5f47a6&scoped=true&"
import script from "./NotificationChannelModal.vue?vue&type=script&lang=js&"
export * from "./NotificationChannelModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationChannelModal.vue?vue&type=style&index=0&id=2c5f47a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f47a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5f47a6')) {
      api.createRecord('2c5f47a6', component.options)
    } else {
      api.reload('2c5f47a6', component.options)
    }
    module.hot.accept("./NotificationChannelModal.vue?vue&type=template&id=2c5f47a6&scoped=true&", function () {
      api.rerender('2c5f47a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/NotificationChannelModal.vue"
export default component.exports